export default __webpack_public_path__ + "static/media/NotoSans-Bold.d1e22e64.eot";